import React from 'react';
import '../../assets/landingPageCss/common.css';
import '../../assets/landingPageCss/style.css';
import '../../assets/landingPageCss/privacy.css';
import Footer from './Footer';
import Navbar from './Navbar';

function Privacy() {
  document.title = 'Adcropper | Privacy';
  return (
    <main className='untitled-page mainContent'>
      <Navbar />
      <section className='privacySection'>
        <div class="privacyWrapper">
          <h1 class="privacyTitle">Privacy Policy</h1>
        </div>
      </section>
      {/* Privacy Text */}
      <section class="privacyTextSection">
        <div class="privacyTextWrapper">
          <p class="privacyText">
            Last Updated: 28.09.2024
          </p>
          <p class="privacyText">Your personal data is of great importance to us. Both international agreements and local
            laws have mandated
            the legal protection of the data of natural and legal persons due to the uncontrolled increase in internet
            usage and data flow.</p>
          <p class="privacyText">By using our product, you consent to the processing of your personal data. You accept
            these agreements by
            ticking the approval checkbox. Marking this checkbox is considered explicit consent for the processing of your
            data. At any time, you can contact us via our provided contact information to withdraw this consent, or you
            can cancel your membership as mentioned in Terms of Use.</p>
          <p class="privacyText">Our company acts as the data controller in accordance with Article 4 of the GDPR and, as
            will be detailed in
            the clauses of this agreement, is responsible for the processing of the personal data of our users and
            members.</p>
          <br />

          <h3 class="privacySubTitle">1. What Personal Data Do We Collect?</h3>
          <p class="privacyText">First and foremost, we would like to emphasize that we collect all the personal data
            provided to us through the form filled out by both individuals and legal entities when registering on our
            site. This data may include any of the following:</p>
          <ul class="privacySubList">
            <li>Identity Information: Details such as name, surname, username, date of birth, ID number, and passport
              number. </li>
            <li>Contact Information: Details such as email address, phone number or postal address. </li>
            <li>Payment and Financial Information: Credit card information, bank account details, billing information.
            </li>
            <li>Device and Connection Information: Technical data such as IP address, browser type, operating system,
              geographic location, and device ID. </li>
            <li>Account and Profile Information: Information provided during account creation, purchase history,
              preferences, interests, and USERS’ settings. </li>
            <li>Transaction Data: Products purchased, transactions, billing details, delivery information. </li>
            <li>Usage Data: Information regarding how the PORTAL is used, browsing behavior, page view statistics, and
              clicked links. </li>
            <li>Cookie Data: Data collected through browser cookies. </li>
            <li>Social Media Information: Information you consent to provide when interacting with our ads on social media
              sites like Instagram, Facebook, Twitter, YouTube, etc. </li>
            <li>Additional Information You Provide: Information you share with us when participating in our surveys and
              other activities.</li>
          </ul>
          <br />

          <h3 class="privacySubTitle">2. How Do We Collect Your Data?</h3>
          <ul class="privacySubList">
            <li>Information you voluntarily share with us directly. (For example, the information you provide when
              creating
              an account or during purchase transactions)</li>
            <li>Technical data automatically collected when you visit our portal. (For example, data collected via IP
              addresses, cookies, and device information) </li>
            <li>Data obtained from platforms integrated with our site, social media platforms, or payment service
              providers, as mentioned in the Terms of Use.</li>
          </ul>
          <br />

          <h3 class="privacySubTitle">3. What is the Purpose of Collecting and Using Your Data?</h3>
          <ul class="privacySubList">
            <li>We process your personal data in accordance with Article 6 of the GDPR to provide our services, fulfill
              the
              contract, comply with legal obligations, and for marketing activities.</li>
            <li>The primary purpose of collecting your personal data is to provide you with our services. Managing user
              accounts, delivering digital products, and offering customer support are just a few of these purposes. </li>
            <li>We also process your personal data to carry out payment transactions and issue invoices accordingly. </li>
            <li>We collect your data to inform you about products and campaigns, offer personalized advertisements, and
              gather feedback from you, our users. </li>
            <li>In addition, we collect data to improve our portal and to prevent fraud attempts.</li>
          </ul>
          <br />

          <h3 class="privacySubTitle">4. What Are Your Rights as a Data Subject?</h3>
          <ul class="privacySubList">
            <li>Articles 12 to 23 of the GDPR explain all the rights granted to data subjects.</li>
            <li>Article 15: You have the right to access your data being processed at any time.</li>
            <li>Article 16: You have the right to request the rectification of your processed data.</li>
            <li>Article 17: You can request the deletion of your data under your right to be forgotten.</li>
            <li>Article 20: You have the right to request the transfer of your data to another data controller.</li>
            <li>Article 21: You have the right to object to the processing of your data at any time.</li>
          </ul>
          <br />

          <h3 class="privacySubTitle">5. Situations Where Your Consent is Required for Data Processing</h3>
          <ul class="privacySubList">
            <li>We request your explicit consent to process your personal data in accordance with Article 7 of the GDPR.
              You have the right to withdraw your consent at any time.</li>
            <li>All the data you share with us when creating an account is collected and processed based on your explicit
              consent.</li>
            <li>The processing of users’ data for marketing purposes is based on explicit consent (for example, sending
              marketing campaigns via email or displaying personalized ads).</li>
            <li>Our company may use cookies to improve users' experience, analyze site traffic, and provide advertising
              services. The processing of your data during the use of cookies is based on your explicit consent. If you do
              not wish to accept these cookies, please click the “Reject” button.</li>
            <li>The data shared with the third parties, such as payment providers and marketing partners, is processed
              based on your explicit consent.</li>
            <li>Providing feedback related to the digital product you purchase does not require your explicit consent.
              However, if these notifications contain marketing content, we will request your explicit consent.</li>
            <li>If necessary for any legal obligations or for site analysis, the retention period of your personal data
              may
              be extended. In such cases, your explicit consent will be obtained again.</li>
          </ul>
          <br />

          <h3 class="privacySubTitle">6. How Long Do We Store Your Data? </h3>
          <p class="privacyText">We will only retain your personal data for as long as it is necessary to provide our
            services, in accordance
            with Article 5 of the GDPR. Once you cancel your account, your name, surname, ID number or tax number, email
            address, and registered site address will be deleted within one year. If you would like your data to be
            deleted immediately, you can submit your request through the contact information provided on our portal.
            However, in accordance with tax and accounting regulations, we are required to retain your financial records,
            payment transaction details, and related information for 10 years.</p>
          <p class="privacyText">For users who are not registered members but have shared their data with us by consenting
            to cookies for
            marketing purposes, their data will be stored from the moment they provide consent until they withdraw it.</p>
          <br />

          <h3 class="privacySubTitle">7. Information Regarding Cookies and Similar Technologies Used on Our Website</h3>
          <p class="privacyText">8.1. Cookies are small data files used to enhance users' experience on a website. These
            files are created by
            the websites you visit and are stored on your browser or device.</p>
          <br />

          <p class="privacyText">8.2. There are various types of cookies:</p>
          <ul class="privacySubList">
            <li>Essential cookies are necessary for the proper functioning of our portal. Some of these include cookies
              that remember your login information and ensure the security of the site. These cookies do not require user
              consent.</li>
            <li>Performance and analytics cookies are used to monitor how our website is used and to assess its
              performance.</li>
            <li>Functional cookies remember user preferences such as language choices or login information while using our
              website.</li>
            <li>Targeting and advertising cookies are used to provide advertisements that are relevant to user interests
              and to measure the effectiveness of advertising campaigns.</li>
            <li>Third-party cookies are cookies used by the company’s service providers, advertising networks, and social
              media platforms, as mentioned in the Terms of Use Agreement. These cookies can offer personalized content or
              advertisements based on data collected by third parties.</li>
          </ul>
          <br />

          <p class="privacyText">8.3. Web beacons and pixel tags are similar to cookies. Web beacons are small, invisible
            graphics used to
            track the effectiveness of websites or email campaigns. Pixel tags are tracking tools often used by social
            media platforms or advertising networks to monitor user behavior and deliver targeted ads.</p>
          <br />

          <p class="privacyText">8.4. The purposes of using cookies can be summarized as follows:</p>
          <p class="privacyText">
            - To ensure the proper functioning of our portal,<br />
            - To personalize your experience and remember your preferences,<br />
            - To analyze and improve the performance of our portal,<br />
            - To personalize advertisements and provide content relevant to your interests,<br />
            - To detect and prevent DDoS attacks and fraudulent activities on our portal, enhancing security.<br />
          </p>
          <br />

          <p class="privacyText">8.5. If you wish to remove or disable cookies, you can click the "Reject Cookies" button.
            However, please note that some functions of the portal may not work correctly if you do not accept these
            cookies.</p>
          <br />

          <p class="privacyText">8.6. All third parties integrated with our portal, as mentioned in the Terms of Use, use
            cookies, and the information regarding their data processing is provided in detail in both agreements.</p>
          <br />

          <h3 class="privacySubTitle">8. How Do We Ensure the Security of Your Data?</h3>
          <ul class="privacySubList">
            <li>
              We use security measures such as encryption, firewalls, access control systems, data masking, and data
              anonymization to ensure the security of your personal data.
            </li>
            <li>
              Only authorized employees with a business need can access your personal data, and this data is protected
              against unauthorized access, data loss, and misuse through security measures.
            </li>
            <li>
              If the security of your personal data is breached, we are obligated to notify you immediately in accordance
              with Article 33 of the GDPR.
            </li>
            <li>
              We use secure data transfer protocols (SSL, TLS) during the transfer of your personal data and ensure that
              third parties processing your data comply with security agreements.
            </li>
            <li>
              Third parties authorized to process your personal data are required to comply with our data security
              standards, and all transactions with these third parties are regularly monitored.
            </li>
            <li>
              We recommend that you use a strong password and refrain from sharing it with anyone to ensure the security
              of your account. Further information regarding your account security is provided in the Terms of Use.
            </li>
            <li>
              We regularly review our data security policies and technical infrastructure and continuously improve them
              against security threats.
            </li>
            <li>
              If we need to transfer your personal data outside the European Economic Area, we will take the necessary
              security measures in accordance with Articles 44-50 of the GDPR.
            </li>
            <li>
              Our data security systems are regularly evaluated through independent audits and certifications, ensuring
              compliance with international standards.
            </li>
          </ul>
          <br />

          <h3 class="privacySubTitle">9. What Do We Do in Case of a Data Breach?</h3>
          <ul>
            <li>
              A data breach refers to the unauthorized disclosure, deletion, loss, alteration, or access to your personal
              data.
            </li>
            <li>
              In the event of a data breach, our company will first detect the breach, assess its scope, and notify the
              data subject/competent supervisory authority. The notification period for the supervisory authority is 72
              hours.
            </li>
            <li>
              If the data breach has serious consequences and your rights and freedoms are at risk, our company will
              notify you immediately in accordance with Article 34 of the GDPR.
            </li>
            <li>
              In the event of a data breach, we will inform you about the nature of the breach, the data affected, the
              measures taken, and the steps you can take to prevent further harm. Additionally, you can request the
              deletion of your data or file a complaint with the competent authorities to protect your rights.
            </li>
            <li>
              After a data breach, we will immediately implement technical and organizational measures to restore the
              security of your personal data and prevent similar incidents from occurring in the future.
            </li>
            <li>
              To prevent data breaches, we protect your personal data through encryption, regular security audits, and
              firewalls.
            </li>
          </ul>
          <br />

          <h3 class="privacySubTitle">10. General Information</h3>
          <p class="privacyText">11.1 Changes to the Privacy Policy</p>
          <p class="privacyText">We reserve the right to update or modify this privacy policy at any time. If we make
            significant changes to this policy, we will notify you through the portal or via email. Your continued use of
            the PORTAL after any changes are posted will constitute your acknowledgment and acceptance of those changes.
          </p>
          <br />

          <p class="privacyText">11.2. Dispute Resolution</p>
          <p class="privacyText">This privacy policy shall be subject to the laws and remedies specified in the “Dispute Resolution” article of the Terms of Use Agreement.</p>
          <br />

          <p class="privacyText">11.3. Contact Information</p>
          <p class="privacyText">For any questions, concerns, or support related to this agreement, please contact us using the [platform.adcropper.com/contact].</p>
          <br />

          <p class="privacyText">11.4. Data Protection Officer (DPO)</p>
          <p class="privacyText">If you would like to contact our Data Protection Officer (DPO) regarding data privacy-related inquiries, you can do so by emailing [DPO Email].</p>
          <br />

          <p class="privacyText">11.5. Severability Clause</p>
          <p class="privacyText">If any provision of this privacy policy is found to be invalid or unenforceable, the remaining provisions will continue in full force and effect.</p>
          <br />

          <p class="privacyText">11.6. Consent and Agreement</p>
          <p class="privacyText">By using our portal and services, you acknowledge that you have read and understood this privacy policy, and you agree to the collection, use, and sharing of your personal data as described in this policy.</p>
          <br />
        </div>
      </section>
      <Footer />
    </main>
  )
}

export default Privacy
